'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUiConsent = exports.SUBMIT_CONSENT_SUCCESS = exports.SUBMIT_CONSENT_REQUEST = exports.SUBMIT_CONSENT_FAIL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.submitConsent = submitConsent;

var _api = require('../api');

var _reselect = require('reselect');

var _user = require('./user');

var _config = require('./config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SUBMIT_CONSENT_FAIL = exports.SUBMIT_CONSENT_FAIL = 'la/ui/consent/FAIL';
var SUBMIT_CONSENT_REQUEST = exports.SUBMIT_CONSENT_REQUEST = 'la/ui/consent/REQUEST';
var SUBMIT_CONSENT_SUCCESS = exports.SUBMIT_CONSENT_SUCCESS = 'la/ui/consent/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: '',
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SUBMIT_CONSENT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false
            });
        case SUBMIT_CONSENT_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: '',
                submitted: true,
                success: false
            });
        case SUBMIT_CONSENT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: '',
                submitted: false,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.consent;
};

var getUiConsent = exports.getUiConsent = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
function setConsentFail(bidderId, error) {
    return {
        error: true,
        meta: { bidderId: bidderId },
        payload: error,
        type: SUBMIT_CONSENT_FAIL
    };
}

function setConsentRequest() {
    return {
        type: SUBMIT_CONSENT_REQUEST
    };
}

function setConsentSuccess(state, attributionData) {
    return {
        meta: {
            actionTime: Date.now()
        },
        payload: 'accepted',
        type: SUBMIT_CONSENT_SUCCESS
    };
}

function submitConsent(consent, context) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch(setConsentRequest());
        return _api.Bidder.postBidderConsent({ authToken: authToken, consent: consent, context: context, deployment: deployment }).then(function () {
            dispatch(setConsentSuccess(getState()));
        }).catch(function (error) {
            dispatch(setConsentFail(error));
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/consent.js
// module id = MllG
// module chunks = 60